'use strict';

var _ = require('lodash');
var modelUtils = require('./../modelUtils');
var DELIMITER = '__';
var SPLITTED_DATA_TYPES = ['data', 'design'];

/* get Array[ids] or Array[{_id:id}] and returns array of id's*/
function getIdsFromItems(items) {
  return _.map(items, function (item) {
    return _.isString(item) ? item : item._id;
  });
}

/*get Array[ids] or Array[{_id:id}] and returns format of {item: itemData, index: index in array}*/
function reduceItems(data, ids) {
  var dataFormatted = _.map(data, function (v) {
    if (_.isString(v)) {
      return { _id: v };
    }
    return v;
  });
  return _.reduce(dataFormatted, function (result, item, index) {
    if (_.includes(ids, item._id)) {
      result.push({ item: item, index: index });
    }
    return result;
  }, []);
}

/*return added repeater items - check what newly ids were added
 * return {item: itemData, index: index in array} */
function getAddedItems(currentData, newData) {
  var newItemsIds = getIdsFromItems(newData);
  var currentDataIds = getIdsFromItems(currentData);
  var newlyAddedItemsIds = _.difference(newItemsIds, currentDataIds);
  return reduceItems(newData, newlyAddedItemsIds);
}

/*return removed repeater items - check what ids were removed
 * return {item: itemData, index: index in array} */
function getRemovedItems(currentData, newData) {
  var newItemsIds = getIdsFromItems(newData);
  var currentDataIds = getIdsFromItems(currentData);
  var removedIds = _.difference(currentDataIds, newItemsIds);
  return reduceItems(currentData, removedIds);
}

function getUniqueDisplayedId(originalId, itemId) {
  return originalId + DELIMITER + itemId;
}

function getOriginalId(uniqueItemId) {
  if (!uniqueItemId) {
    return;
  }
  return uniqueItemId.split(DELIMITER)[0];
}

function getItemId(uniqueItemId) {
  if (!uniqueItemId) {
    return;
  }
  return uniqueItemId.split(DELIMITER)[1];
}

function getTemplateCompIds(RMI, repeaterId, itemsData) {
  var templateCompIds = modelUtils.getAllCompsUnderRoot(_.get(RMI, '_model'), repeaterId);
  var itemsId = _.compact(_.map(itemsData, function (itemData) {
    return _.get(itemData, 'item._id');
  }));
  return _.reduce(itemsId, function (result, itemId) {
    return result.concat(_.map(templateCompIds, function (templateCompId) {
      return getUniqueDisplayedId(templateCompId, itemId);
    }));
  }, []);
}

module.exports = {
  getAddedItems: getAddedItems,
  getRemovedItems: getRemovedItems,
  getUniqueDisplayedId: getUniqueDisplayedId,
  getOriginalId: getOriginalId,
  getItemId: getItemId,
  getTemplateCompIds: getTemplateCompIds,
  SPLITTED_DATA_TYPES: SPLITTED_DATA_TYPES
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/repeaterUtils/repeaterItemsUtils.js